import { AxiosService } from './axios.service'
const baseURL = 'pontos-bonus'

/**
 * Defines the API methods for bonus points
 */
export default class BonusPointsService {
	/**
	 * Get the bonus points for round trip
	 * @return {Promise<number>} Bonus points
	 */
	static getBonusPointsForRoundTrip(params) {
		return AxiosService.get(`${baseURL}/ida-e-volta`, { params }).then(
			({ data }) => data
		)
	}
}
